import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t, i18n } = useTranslation();
  
  const scrollToSignup = () => {
    const signupSection = document.getElementById('signup');
    if (signupSection) {
      signupSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const isChineseVersion = i18n.language === 'zh-TW';

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-6 py-20">
      {/* Ambient Background Effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              {isChineseVersion ? (
                <h1 className="text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight font-['Space_Grotesk']">
                  <div className="text-4xl lg:text-6xl xl:text-7xl">{t('hero.title.part1')}</div>
                  <div className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">
                    {t('hero.title.part2')}
                  </div>
                </h1>
              ) : (
                <h1 className="text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight font-['Space_Grotesk']">
                  {t('hero.title.part1')}{' '}
                  <span className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">
                    {t('hero.title.part2')}
                  </span>
                </h1>
              )}
              
              <p className="text-lg lg:text-xl text-slate-300 leading-relaxed font-light">
                {t('hero.description')} <em className="not-italic font-semibold text-teal-400">{t('hero.description.highlight')}</em>{t('hero.description.part2')}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToSignup}
                className="px-8 py-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white font-semibold rounded-lg hover:from-teal-600 hover:to-emerald-600 transition-all duration-300 shadow-lg shadow-teal-500/25 hover:shadow-teal-500/40 whitespace-nowrap cursor-pointer"
              >
                {t('hero.joinEarlyAccess')}
              </button>
              <button 
                onClick={() => {
                  const featuresSection = document.getElementById('features');
                  if (featuresSection) {
                    featuresSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="px-8 py-4 bg-slate-800/50 text-white font-semibold rounded-lg hover:bg-slate-800 transition-all duration-300 border border-slate-700 whitespace-nowrap cursor-pointer"
              >
                {t('hero.learnMore')}
              </button>
            </div>
          </div>

          {/* Right: Hero Image */}
          <div className="relative">
            <div className="relative aspect-square rounded-2xl overflow-hidden">
              <img 
                src={isChineseVersion 
                  ? "https://static.readdy.ai/image/584ac40951726429431482b4d17e4edf/fc4a588487a320b27451faa7d094c926.jpeg"
                  : "https://static.readdy.ai/image/584ac40951726429431482b4d17e4edf/e540f7a38c1c3b846381f4666a30e3c8.png"
                }
                alt="Scroll Companion AI Assistant"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}